import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import AppSections from "../utils/AppSections";
import _3dInstances from "../ui/_3d_instances/_3dInstances";
import _3dInstanceDetails from "../ui/_3d_instances/_3dInstanceDetails";
import _3dInstanceAddEdit from "../ui/_3d_instances/_3dInstanceAddEdit";
import TextureAddEdit from "../ui/textures/TextureAddEdit";
import SpatialRelationsAddEdit from "../ui/spatial_relations/SpatialRelationsAddEdit";
import AnnotationsAddEdit from "../ui/annotations/AnnotationsAddEdit";

const _3dInstanceRoutes = (
  <Route
    path={AppSections._3DINSTANCES}
    element={
      <ProtectedRoute>
        <_3dInstances />
      </ProtectedRoute>
    }
  >
    <Route path=":id/view" element={<_3dInstanceDetails />} />
    <Route path=":id/edit" element={<_3dInstanceAddEdit />} />

    {/* textures routes */}
    <Route path=":e3dinstid/textures/create" element={<TextureAddEdit />} />

    {/* annotations routes */}
    <Route
      path=":e3dinstid/annotations/create"
      element={<AnnotationsAddEdit />}
    />

    {/* Spatial Relations routes */}
    <Route
      path=":id/spatialrelations/create"
      element={<SpatialRelationsAddEdit />}
    />
  </Route>
);

export default _3dInstanceRoutes;
